module.exports = __webpack_public_path__ + "static/士林捷運站-DSC05178-af3351e2fdb1888c22901aa8eeddb28c.jpg";